import { Route } from 'vue-router';
import Token from '@/support/Token';
import store from '@/store';

// eslint-disable-next-line
export default async (to: Route, from?: Route, next?: any) => {
  if (! Token.get('access')) {
    return next();
  }

  if (! store.getters.user) {
    return next();
  }

  return next();
};
